import { useEffect, useRef } from 'react';
import { GOOGLE_MERCHANT_ID } from '../../utils/googleCustomerReviews';

const WIDGET_SCRIPT_ID = 'merchantWidgetScript';
const WIDGET_SCRIPT_SRC = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';

/**
 * Google Müşteri Yorumları satıcı rozeti (Merchant Center).
 * @see https://support.google.com/merchants/answer/7124326
 */
const GoogleMerchantReviewBadge = () => {
  const startedRef = useRef(false);

  useEffect(() => {
    const startWidget = () => {
      if (startedRef.current) return;
      if (typeof window.merchantwidget?.start !== 'function') return;

      startedRef.current = true;
      window.merchantwidget.start({
        merchant_id: GOOGLE_MERCHANT_ID,
        position: 'BOTTOM_RIGHT',
        region: 'TR',
      });
    };

    let script = document.getElementById(WIDGET_SCRIPT_ID);

    if (script) {
      script.addEventListener('load', startWidget);
      if (window.merchantwidget) {
        startWidget();
      }
      return () => script.removeEventListener('load', startWidget);
    }

    script = document.createElement('script');
    script.id = WIDGET_SCRIPT_ID;
    script.src = WIDGET_SCRIPT_SRC;
    script.defer = true;
    script.addEventListener('load', startWidget);
    document.body.appendChild(script);

    return () => {
      script.removeEventListener('load', startWidget);
    };
  }, []);

  return null;
};

export default GoogleMerchantReviewBadge;
